// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const File: React.FC<{ width?: number; height?: number }> = ({ width = 12, height = 16 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 12 16">
            <path
                fill="currentColor"
                d="M2 0C.906 0 0 .906 0 2v12c0 1.094.906 2 2 2h8c1.094 0 2-.906 2-2V5.344c0-.532-.219-1.063-.594-1.438L8.094.594A2 2 0 0 0 6.688 0zm8.188 5.5H7.25a.76.76 0 0 1-.75-.75V1.844z"
            />
        </svg>
    );
};

export default React.memo(File);
